import { makeStyles } from '@material-ui/core';

const useVerifyStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  return ({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    tealBlueBg: {
      backgroundColor: 'var(--teal-blue)',
      background: 'linear-gradient(229.09deg, #005C82 15.41%, #0B9EDB 114.14%)',
      [mobileBreakpoint]: {
        backgroundColor: 'var(--white)',
      },
    },
    form: {
      width: '100%',
      marginTop: theme.spacing(1),
    },
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    subtitle: {

    },
    input: {
      backgroundColor: 'var(--white)'
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    }
  });
});

export default useVerifyStyles;
